import { useFormik } from "formik";
import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import callApi from "services/api";
import { selectLoading, setLoading } from "state/slices/loaderSlice";
import { setLoginStatus } from "state/slices/loginSlice";
import { setLoginView } from "state/slices/loginViewSlice";
import { generateSHA512HashAndEncryptInES6 } from "utils/Encryption";
import * as Yup from "yup";

const LoginPage = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please enter your Username."),
      password: Yup.string().required(
        "Please provide your password to proceed."
      ),
    }),
    onSubmit: async (values) => {
      const encryptedData = {
        username: values.username,
        password: generateSHA512HashAndEncryptInES6(values?.password),
      };
      await login(encryptedData);
    },
  });

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      formik.handleSubmit();
    }
  };

  const login = async (formdata) => {
    dispatch(setLoading(true));
    var response = await callApi(
      "/authenticate",
      "POST",
      formdata,
      true,
      false,
      dispatch,
      navigate
    );
    if (response?.success) {
      const body = response?.body;
      if (body?.token) {
        localStorage.setItem("token", body?.token);
        dispatch(setLoginStatus(true));
        navigate('/')
      }
    }
    dispatch(setLoading(false));
  };


  return (
    <>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card mt-3">
            <div className="card-face card-front">
              <div className="card-body">
                <h3 className="card-title text-center">Login</h3>
                <h6 className="text-secondary">
                  Welcome ! Please enter your details.
                </h6>
                <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
                  <div className="mb-3">
                    <label htmlFor="username" className="form-label mt-3">
                      Username
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="username"
                      name="username"
                      className={`form-control ${formik.touched.username && formik.errors.username
                        ? "is-invalid"
                        : ""
                        }`}
                      {...formik.getFieldProps("username")}
                      placeholder="Enter Username"
                      autoComplete="username"
                      maxLength={100}
                    />
                    {formik.touched.username && formik.errors.username && (
                      <div className="invalid-feedback">
                        {formik.errors.username}
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="username" className="form-label">
                      Password:<span className="text-danger">*</span>
                    </label>
                    <div className="position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        className={`form-control ${formik.touched.password && formik.errors.password
                          ? "is-invalid"
                          : ""
                          }`}
                        {...formik.getFieldProps("password")}
                        placeholder="Enter Password"
                        maxLength={50}
                      />
                      <span
                        className="position-absolute top-50 end-0 translate-middle-y"
                        onClick={() => setShowPassword((prev) => !prev)}
                        style={{
                          cursor: "pointer",
                          marginRight: formik.errors.password
                            ? "1.99rem"
                            : "1rem",
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    {formik.touched.password && formik.errors.password && (
                      <div
                        style={{
                          color: "#f03d3d",
                          fontSize: "0.75rem",
                          marginTop: "0.375rem",
                        }}
                      >
                        {formik.errors.password}
                      </div>
                    )}
                  </div>

                  <div className="d-flex justify-content-center">
                    <button className="btn btn-info w-100" disabled={loading}>
                      Login
                    </button>
                  </div>
                </form>
                <div className="mt-3 d-flex align-items-center justify-content-center">
                  <h6 className="text-secondary">Forgot your password?</h6>
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      dispatch(setLoginView("forgot-password"));
                    }}
                  >
                    Click Here
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
